import { Injectable } from '@angular/core';
import AWN from "awesome-notifications"

@Injectable({
    providedIn: 'root'
})
export class Utils {

    public static notification = new AWN()

    /** Safety cap for the "code already taken" retry loop, so a persistently rejected code can't retry forever. */
    public static readonly MAX_CODE_ALREADY_TAKEN_RETRIES = 20;

    /** Pulls a readable message out of the various shapes ErrorInterceptor can hand back (string, { message }, { errors }). */
    public static extractErrorMessage(error: any, field: string = 'code'): string {
        if (typeof error === 'string') return error;
        if (typeof error?.message === 'string') return error.message;

        const fieldErrors = error?.errors?.[field] ?? error?.errors;
        if (typeof fieldErrors === 'string') return fieldErrors;
        if (Array.isArray(fieldErrors)) return String(fieldErrors[0] ?? '');
        if (fieldErrors && typeof fieldErrors === 'object') {
            const first = Object.values(fieldErrors)[0];
            return Array.isArray(first) ? String(first[0] ?? '') : String(first ?? '');
        }

        return '';
    }

    /** True when the save error is the backend's "code already taken" uniqueness validation. */
    public static isCodeAlreadyTakenError(error: any, field: string = 'code'): boolean {
        return Utils.extractErrorMessage(error, field).toLowerCase().includes(`${field} has already been taken`);
    }

    /** Increments a code value by 1, preserving leading-zero padding when the current value is purely numeric. */
    public static incrementCode(currentCode: any): any {
        if (currentCode == null) return currentCode;

        const currentCodeStr = String(currentCode);
        const nextValue = (parseInt(currentCodeStr, 10) || 0) + 1;

        return /^\d+$/.test(currentCodeStr)
            ? String(nextValue).padStart(currentCodeStr.length, '0')
            : String(nextValue);
    }

    /**
     * Enfoca el siguiente campo del <form> que contiene a `element`, como si se pulsase Tab.
     * Se difiere al siguiente tick porque quien llama a esto normalmente lo hace justo después
     * de cambiar algo (p.ej. cerrar un dropdown) y la app es zoneless: el DOM puede no reflejar
     * aún ese cambio en el mismo tick, dando un "siguiente" equivocado (p.ej. un botón de un
     * dropdown que está a punto de desaparecer).
     */
    public static focusNextFormField(element: HTMLElement): void {
        const form = element.closest('form');
        if (!form) return;

        setTimeout(() => {
            const focusable = Array.from(
                form.querySelectorAll<HTMLElement>(
                    'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([disabled])'
                )
            ).filter(el => el.tabIndex !== -1 && el.offsetParent !== null);

            const currentIndex = focusable.indexOf(element);
            if (currentIndex === -1) return;

            focusable[currentIndex + 1]?.focus();
        }, 0);
    }

}